import { render, staticRenderFns } from "./v-mainHeaderContent.vue?vue&type=template&id=61f28634&"
import script from "./v-mainHeaderContent.vue?vue&type=script&lang=js&"
export * from "./v-mainHeaderContent.vue?vue&type=script&lang=js&"
import style0 from "./v-mainHeaderContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports